import './App.css';
import Navbar from './components/navbar';
import Footer from './components/footer';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import Home from './screens/homescreen';
import Blog from './screens/blogscreen';
import Contact from './screens/contactscreen';
import Privacy from './screens/privacyscreen';
import Terms from './screens/termsscreeen';
import MaintenancePage from './components/MaintenancePage/MaintenancePage'; 

function ScrollToHash() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [hash]);

  return null; // This component only handles side effects
}

function App() {
  return (
    <div className="App">
                 <MaintenancePage/>

      {/* <Router>
        <ScrollToHash /> Handles smooth scrolling
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
        <Footer />
      </Router> */}
    </div>
  );
}

export default App;
